<template>
	<div class="order-item">
		<div class="header">
			<span>订单编号：{{order_no||""}}</span>
			<span>{{created_at||''}}</span>
		</div>
		<div class="card">
			<el-image class="img flex-shrink" :src="product_img" v-if="product_img" :fit="'cover'"></el-image>
			<div class="base">
				<div class="title">{{product_class||''}}</div>
				<div class="num">数量：{{product_number||0}}</div>
				<Tag color="success" v-if="order_type == 2">一口价</Tag>
				<Tag color="warning" v-if="order_type == 1">报价招标</Tag>
			</div>
			<div class="service">
				<div>联系人</div>
				<div class="content">{{contact||""}}</div>
			</div>
			<div class="contact">
				<div class="phone">电话：{{phone||""}}</div>
				<div class="address text-cut-4">{{address||""}}</div>
			</div>
			<div class="service">
				<div>服务类型</div>
				<div class="content">{{service_name||""}}</div>
			</div>
			<div class="service">
				<div>状态</div>
				<div class="content" v-if='order_type==1'>{{status_name||""}}</div>
				<div class="content" v-else>{{status==2?'待抢单':status_name||""}}</div>
			</div>
			<div class="service">
				<div>{{status<3?'市场参考价':'订单金额'}}</div>
				<div class="content">￥{{price||0}}</div>
				<!--        <div class="time">剩余时间：20小时30分</div>-->
			</div>
			<div class="remark">
				<div>订单备注</div>
				<span class="remark-total" v-if="remarkCount">({{remarkCount}})</span>
				<div class="remark-list" v-if="latestRemark">
					<div class="remark-item" :title="latestRemark.content" @click="openRemark()">
						<span class="flag-icon" :style="{'--flag-color': latestRemark.color}"></span>
						<span class="remark-content">{{latestRemark.content}}</span>
						<span class="remark-text">备注</span>
					</div>
				</div>
				<div class="remark-empty" v-else @click="openRemark()">
					<span class="flag-icon" :style="{'--flag-color': remarkForm.color}"></span>
					<span>备注</span>
				</div>
			</div>
			<!-- 1待报价,2待雇佣,3待支付,4待上门,5服务中,6待验收,7待评价,8已完成,9交易关闭,10第二次上门,11第一次售后,12第二次售后 -->
			<div class="handle flex-direction flex justify-center align-end">
				<el-button type="success" size="small" v-if="status ==3"
					@click="$router.push({name:'order_pay',params:{id:id}})">立即付款</el-button>
          <el-button type="primary" size="mini" class="margin-top" v-if="status ==1"
          	@click="changeOrder()">修改订单
          </el-button>
				<el-button type="primary" size="mini" class="margin-top" v-if="status <= 4&&status!=3"
					@click="cancel()">取消订单
				</el-button>
				<el-button type="primary" size="mini" class="margin-top" v-if="status ==4||status ==5" style="margin: 20rpx 0;" @click="$router.push({ name: 'order_pay', params: { id: id, type: 'addMoney' } })">增加费用
				</el-button>
				<el-button type="primary" size="mini" class="margin-top" v-if="status ==4" @click="tipsBtn()">催师傅上门
				</el-button>
				<el-button type="info" size="small" v-if="status ==6"
					@click="$router.push({name:'order_refund',params:{id:id}})">申请退款</el-button>
				<el-button type="primary" size="small" v-if="status ==6" @click="confirmReciv()">确认验收</el-button>
				<!-- <el-button type="primary" size="small"  v-if="status ==6" @click="goCompleteCode()">出示完工码</el-button> -->
				<el-button type="success" size="small" v-if="status ==7"
					@click="$router.push({name:'order_evaluate',params:{id:id}})">去评价</el-button>
				<el-button type="success" size="small" v-if="status ==2&&order_type==1"
					@click="$router.push({name:'order_detail',params:{id:id,activwName:'second'}})">雇佣师傅</el-button>
				<!--  -->
				<el-button type="danger" size="small" @click="delOrder()" v-if="status ==8||status ==9||status > 14">
					删除订单
				</el-button>
				<el-button size="small" @click="$router.push({name:'order_detail',params:{id:id}})">查看详情</el-button>
				<!-- <div class="info-btn line-eee wn50 padding-tb-4 radius-6" @click="$router.push({name:'order_detail',params:{id:id}})">查看详情</div> -->
			</div>
		</div>
		<el-dialog title="订单标记 / 备注" :visible.sync="remarkModal" width="680px" custom-class="remark-dialog">
			<div class="remark-form">
				<div class="remark-history" v-if="remarkList.length">
					<div class="remark-history-item" v-for="(item, index) in remarkList" :key="index">
						<span class="flag-icon" :style="{'--flag-color': item.color}"></span>
						<span class="remark-history-content">{{item.content}}</span>
					</div>
				</div>
				<div class="remark-form-row">
					<span class="remark-form-label">旗帜颜色：</span>
					<div class="flag-select-list">
						<span
							class="flag-select"
							:class="{active: remarkForm.color === item}"
							v-for="item in flagColors"
							:key="item"
							@click="remarkForm.color = item">
							<span class="flag-icon" :style="{'--flag-color': item}"></span>
						</span>
					</div>
				</div>
				<div class="remark-form-row remark-textarea-row">
					<span class="remark-form-label">备注内容：</span>
					<div class="remark-textarea-box">
						<el-input
							type="textarea"
							:rows="5"
							maxlength="200"
							placeholder="标记内容仅自己可见，200字以内"
							v-model="remarkForm.remark">
						</el-input>
						<div class="remark-count">{{remarkForm.remark.length}}/200</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="clearRemark">清空</el-button>
				<el-button @click="remarkModal = false">取消</el-button>
				<el-button type="primary" :loading="remarkLoading" @click="saveRemark">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	const ORDER_REMARK_API = '690000000001'
	const ORDER_REMARK_LIST_API = '690000000002'

	export default {
		name: 'order-item',
		props: {
			order_no: {
				type: String,
				default: ""
			},
			product_img: {
				type: String,
				default: ""
			},
			contact: {
				type: String,
				default: ""
			},
			status_name: {
				type: String,
				default: ""
			},
			created_at: {
				type: String,
				default: ""
			},
			phone: {
				type: String,
				default: ""
			},
			address: {
				type: String,
				default: ""
			},
			service_name: {
				type: String,
				default: ""
			},
			product_class: {
				type: String,
				default: ""
			},
			product_number: {
				type: Number,
				default: ""
			},
			order_type: {
				type: Number,
				default: 1
			},
			price: {
				type: String,
				default: ""
			},
			status: {
				type: Number,
				default: 0
			},
			id: {
				type: Number,
				default: 0
			},
			remark: {
				type: String,
				default: ""
			},
			remark_list: {
				type: [Array, String, Object],
				default: () => []
			},
			remark_count: {
				type: [Number, String],
				default: 0
			},
			flag_color: {
				type: String,
				default: ""
			},
		},
		data() {
			return {
				remarkModal: false,
				remarkLoading: false,
				remarkListLoading: false,
				flagColors: ['#ff4d4f', '#ff7a00', '#faad14', '#52c41a', '#315ce7', '#13b5b1', '#722ed1', '#eb2f96'],
				remarkForm: {
					remark: '',
					color: this.flag_color || '#ff4d4f'
				},
				remarkList: this.formatRemarkList(),
				remarkTotal: Number(this.remark_count) || 0
			}
		},
		computed: {
			remarkCount() {
				return this.remarkTotal || this.remarkList.length
			},
			latestRemark() {
				const getRank = item => {
					const time = item.created_at || item.create_time || item.created_time || item.add_time || item.updated_at || item.update_time || ''
					return Date.parse(time) || Number(item.id || item.remark_id || 0) || 0
				}
				return this.remarkList.slice().sort((a, b) => getRank(b) - getRank(a))[0] || null
			}
		},
		watch: {
			remark() {
				this.remarkList = this.formatRemarkList()
			},
			remark_list() {
				this.remarkList = this.formatRemarkList()
			},
			remark_count(value) {
				this.remarkTotal = Number(value) || this.remarkList.length
			},
			flag_color(value) {
				this.remarkForm.color = value || this.remarkForm.color
			}
		},
		methods: {
			getRemarkList() {
				let vm = this
				this.remarkListLoading = true
				this.$request(ORDER_REMARK_LIST_API, {
					order_id: vm.id,
					page: 1
				}).then(res => {
					const data = res.data.data || []
					const list = Array.isArray(data) ? data : (data.list || data.data || data.rows || [])
					const total = Array.isArray(data) ? list.length : (data.total || data.count || data.listCount || data.list_count || list.length)
					vm.remarkList = list.map(item => {
						return {
							content: item.remark || item.remarks || item.content || item.note || item.text || '',
							color: item.color || item.flag_color || item.remark_color || '#ff4d4f',
							id: item.id,
							remark_id: item.remark_id,
							created_at: item.created_at,
							create_time: item.create_time,
							created_time: item.created_time,
							add_time: item.add_time,
							updated_at: item.updated_at,
							update_time: item.update_time
						}
					}).filter(item => item.content)
					vm.remarkTotal = Number(total) || vm.remarkList.length
				}).finally(() => {
					vm.remarkListLoading = false
				})
			},
			formatRemarkList() {
				const defaultColor = this.flag_color || '#ff4d4f'
				const source = this.remark_list
				const normalize = item => {
					if (!item) return null
					if (typeof item === 'string') {
						return {
							content: item,
							color: defaultColor
						}
					}
					const content = item.remark || item.remarks || item.content || item.note || item.text || ''
					return content ? {
						content,
						color: item.flag_color || item.remark_color || item.color || defaultColor,
						id: item.id,
						remark_id: item.remark_id,
						created_at: item.created_at,
						create_time: item.create_time,
						created_time: item.created_time,
						add_time: item.add_time,
						updated_at: item.updated_at,
						update_time: item.update_time
					} : null
				}
				if (Array.isArray(source) && source.length) {
					return source.map(normalize).filter(Boolean)
				}
				const singleRemark = normalize(source) || normalize(this.remark)
				return singleRemark ? [singleRemark] : []
			},
			openRemark() {
				this.remarkForm.remark = ''
				this.remarkForm.color = this.flag_color || this.remarkForm.color
				this.remarkModal = true
			},
			clearRemark() {
				this.remarkForm.remark = ''
			},
			saveRemark() {
				let vm = this
				if (!this.remarkForm.remark) {
					this.$message.error('请输入备注内容')
					return
				}
				this.remarkLoading = true
				this.$request(ORDER_REMARK_API, {
					order_id: vm.id,
					remark: vm.remarkForm.remark,
					color: vm.remarkForm.color,
					is_common: 1
				}).then(() => {
					vm.remarkModal = false
					vm.$emit('refresh')
					vm.$message.success('备注保存成功')
				}).finally(() => {
					vm.remarkLoading = false
				})
			},
			confirmReciv() {
				let vm = this
				this.$util.throttle(() => {
					this.$request('614a8b63980c2', {
						order_id: vm.id,
					}).then(res => {
						this.$Confirm({
							title: '验收提醒',
							showCancel: false,
							desc: '如果师傅已经完成服务，请将下方核销码告知师傅，确认验收',
							text: res.data.data.finished_code
						}).then(res => {
							console.log(res)
						})
					})
				}, 2000, true)

			},
      // 修改订单
      changeOrder(){
        this.$router.push({
          name: 'place',
          params:{order_id:this.id}
        })
      },
			cancel() {
				let vm = this
				this.$cancelOrder({
					id: vm.id,
				}).then(res => {
					if (res == "confirm") {
						console.log("----")
						this.$message.success("操作成功")
						location.reload();
					}
				})
			},
			// 催师傅上门
			tipsBtn() {
				let vm = this
				this.$request('62d52495589e7', {
					order_id: vm.id,
				}).then(res => {
					this.$message({
						type: 'success',
						message: '提醒成功!'
					});
				})
			},
			// 删除订单
			delOrder() {
				let vm = this
				this.$confirm('此操作将删除此订单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$request('614c4dbce8c6d', {
						order_id: vm.id,
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						location.reload();
					})
				}).catch((err) => {
					console.log(err, 'err');
					this.$message({
						type: 'info',
						message: '删除失败'
					});
				});
			},
		}
	}
</script>

<style scoped lang="less">
	.order-item {
		margin-top: 15px;

		.header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: #f7f8fa;
			height: 40px;
			padding: 0 10px;
			font-size: 14px;
		}

		.card {
			width: 100%;
			min-height: 100px;
			margin: 10px auto;
			display: flex;
			align-items: center;

			.img {
				width: 80px;
				height: 80px;
			}

			.base {
				width: 17%;
				margin-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.ivu-tag {
					display: inline-block;
					flex: none;
					width: 75px;
					text-align: center;
				}

				.num {
					color: #999;
				}
			}

			.contact {
				width: 17%;

				.address {
					color: #999999;
					margin-top: 5px;
					font-size: 12px;
				}
			}

			.service {
				width: 12%;
				margin-left: 30px;

				.content {
					font-size: 18px;
					font-weight: 600;
					margin-top: 5px;
				}
			}

			.remark {
				width: 10%;
				min-width: 120px;
				margin-left: 30px;
				color: #111111;

				> div:first-child {
					display: inline-block;
				}

				.remark-total {
					margin-left: 4px;
					color: #999999;
					font-size: 12px;
				}

				.remark-list {
					margin-top: 8px;
				}

				.remark-item {
					display: flex;
					align-items: center;
					width: 100%;
					min-width: 0;
					margin-bottom: 6px;
					cursor: pointer;
				}

				.remark-text {
					display: none;
					color: #999999;
					font-size: 12px;
					line-height: 20px;
				}

				.remark-content {
					flex: 1;
					min-width: 0;
					max-width: 100%;
					overflow: hidden;
					color: #999999;
					font-size: 12px;
					line-height: 20px;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.remark-empty {
					color: #999999;
					font-size: 12px;
					line-height: 20px;
					margin-top: 8px;
					cursor: pointer;
					display: flex;
					align-items: center;
				}
			}

			.handle {
				flex: 1;
				text-align: center;

				.btn {
					margin-top: 15px;
					margin-bottom: 5px;
					padding: 0px 20px;
				}

				.info-btn {
					cursor: pointer;
				}
			}
		}
	}

	/deep/.el-button {
		margin: 6px 0;
	}

	.flag-icon {
		position: relative;
		display: inline-block;
		width: 15px;
		height: 16px;
		margin: 0 6px 0 0;
		flex-shrink: 0;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 3px;
			height: 16px;
			background-color: var(--flag-color);
		}

		&::after {
			content: '';
			position: absolute;
			left: 3px;
			top: 0;
			width: 10px;
			height: 8px;
			background-color: var(--flag-color);
			clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 65%, 0 100%);
		}
	}

	.remark-form {
		.remark-history {
			max-height: 180px;
			overflow-y: auto;
			margin-bottom: 22px;
			padding: 10px 12px;
			background-color: #fafafa;
			border: 1px solid #eeeeee;
			border-radius: 4px;
		}

		.remark-history-item {
			display: flex;
			align-items: flex-start;
			color: #666666;
			font-size: 13px;
			line-height: 20px;

			& + .remark-history-item {
				margin-top: 8px;
			}

			.flag-icon {
				margin-top: 2px;
			}
		}

		.remark-history-content {
			flex: 1;
			word-break: break-all;
		}

		.remark-form-row {
			display: flex;
			align-items: center;
			margin-bottom: 24px;
		}

		.remark-textarea-row {
			align-items: flex-start;
			margin-bottom: 0;
		}

		.remark-form-label {
			width: 90px;
			color: #333333;
			flex-shrink: 0;
		}

		.flag-select-list {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
		}

		.flag-select {
			width: 42px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			border: 1px solid transparent;
			border-radius: 7px;
			margin-right: 6px;
			box-sizing: border-box;

			.flag-icon {
				margin-right: 0;
			}

			&.active {
				border-color: #2a89ff;
				box-shadow: 0 0 0 2px rgba(42, 137, 255, 0.08);
			}
		}

		.remark-textarea-box {
			flex: 1;
			position: relative;
		}

		.remark-count {
			color: #999999;
			font-size: 12px;
			text-align: right;
			margin-top: 8px;
		}
	}

	/deep/.remark-dialog {
		border-radius: 5px;
		margin: 0 !important;

		.el-dialog__body {
			padding: 26px 16px 14px;
		}

		.el-dialog__footer {
			padding: 8px 16px 16px;
			text-align: right;
		}

		.el-textarea__inner {
			min-height: 116px !important;
			border-color: #ff9d2e;
		}

		.el-button--primary {
			background-color: #ff9d2e;
			border-color: #ff9d2e;
		}

		.dialog-footer {
			.el-button {
				margin: 0 0 0 10px;
			}

			.el-button:first-child {
				margin-left: 0;
			}
		}
	}

	/deep/.el-dialog__wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
